import { Components, Theme } from '@mui/material';

import MuiButton from './muiButton';
import MuiIconButton from './muiIconButton';
import MuiInput from './muiInput';
import MuiOutlinedInput from './muiOutlinedInput';
import MuiSelect from './muiSelect';
import MuiTab from './muiTab';
import MuiTableCell from './muiTableCell';
import MuiTooltip from './muiTooltip';
import MuiAutocomplete from './muiAutocomplete';
import MuiGrid from './muiGrid';

const components: Components<Omit<Theme, 'components'>> = {
  MuiUseMediaQuery: {
    defaultProps: {
      noSsr: true,
    },
  },
  MuiButton,
  MuiIconButton,
  MuiInput,
  MuiOutlinedInput,
  MuiSelect,
  MuiTab,
  MuiTableCell,
  MuiTooltip,
  MuiAutocomplete,
  MuiGrid,
};

export default components;
